import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import '@app/styles/global.css';
import { initSentry } from '@/instrument';

const rootEl = document.getElementById('root');
if (rootEl === null) throw new Error('Root element not found');

// App (and transitively the Sentry-wrapped router in routes/index.tsx) is imported
// dynamically so it only loads after Sentry.init() has run — otherwise the router
// module evaluates and starts its pageload span before there's a client to attach to.
function renderApp(): void {
  import('@app/App').then(({ App }) => {
    createRoot(rootEl!).render(
      <StrictMode>
        <Sentry.ErrorBoundary fallback={<div>Something went wrong.</div>} showDialog={false}>
          <App />
        </Sentry.ErrorBoundary>
      </StrictMode>
    );
  });
}

initSentry().finally(renderApp);
